import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "@/components/shared/AuthShell";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Senha redefinida! Faça login.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Redefinir senha"
      subtitle="Escolha uma nova senha."
      footer={<p className="text-sm text-center text-muted-foreground"><Link to="/login" className="text-primary hover:underline">Voltar ao login</Link></p>}
    >
      {!token ? (
        <div className="rounded-lg border border-destructive/40 bg-destructive/10 p-4 text-sm">Token inválido ou ausente.</div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="password">Nova senha</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="reset-password" />
          </div>
          <Button type="submit" className="w-full" disabled={loading} data-testid="reset-submit">
            {loading ? "…" : "Redefinir senha"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
